//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  states,
  stateNameByValue,
  stateValueByAbbreviation,
  stateNameByAbbreviation,
} from "~/src/states.js";

export default {
  props: {
    data: {
      required: false,
    },
    cta: {
      required: true,
    },
    whiteBg: {
      required: false,
      default: false,
    },
  },

  computed: {
    getStates() {
      return states;
    },
  },
};
